// W452: UNA sola regola in tutta l'app (campanella, La mia area, scheda dipendente, dashboard
// della commessa, report, relazione): un'attività è «in ritardo» se ha una scadenza passata e
// non è completata, annullata o sospesa. Prima ogni pagina aveva la sua e i numeri non tornavano.
export const STATI_NON_ATTIVI = ["completata", "completed", "annullata", "sospesa"];
export const attivitaAttiva = (task) => !!task && !STATI_NON_ATTIVI.includes(task.status);

// Verifica se un'attività è scaduta considerando data E ora
export function isTaskOverdue(task) {
  if (!task?.dueDate) return false;
  if (!attivitaAttiva(task)) return false;

  const now = new Date();
  const dueDateTime = task.dueTime
    ? new Date(`${task.dueDate}T${task.dueTime}`)
    : new Date(`${task.dueDate}T23:59:59`); // senza orario: scade a fine giornata

  return dueDateTime < now;
}

// Calcola i giorni rimanenti (può essere negativo se scaduto)
export function daysUntilDue(task) {
  if (!task.dueDate) return Infinity;
  const now = new Date();
  const due = new Date(`${task.dueDate}T${task.dueTime || "23:59:59"}`);
  return (due - now) / (1000 * 60 * 60 * 24);
}
